import { memo as Memo, useRef, useEffect } from 'react';
import { TweenMax } from 'gsap';

//* Components
import Text from '@components/global/Text';
import OurSocialContacts from '@components/global/OurSocialContacts';

//* Styles
import ContactsLinkStyle from './style';

const ContactsLink = Memo((props) => {
	//! Refs
	let ref = useRef();

	useEffect(() => {
		props.animate &&
			TweenMax.staggerTo(
				ref.current.children,
				0,
				{
					opacity: 1,
				},
				0.1
			);
	}, [ref, props.animate]);

	return (
		<ContactsLinkStyle className={'followUsCont'}>
			<div
				ref={ref}
				className={'followUs'}>
				<Text tag={'span'}>
					<Text
						className={'p-l font-poppins font-light font-italic followUsTitle'}
						text={'follow'}
					/>
					&#160;
				</Text>

				<OurSocialContacts />
			</div>
		</ContactsLinkStyle>
	);
});

export default ContactsLink;
